import React, { ChangeEvent, FC } from "react";
import NumberFormat from "react-number-format";

interface FormFieldProps {
    label?: string;
    value?: string;
    placeholder?: string;
    onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
    className?: string;
    required?: boolean;
    name?: string;
    hidelabel?: boolean
    disabled?: boolean
    labelClassName?:string
}

const NumberFormatField: FC<FormFieldProps> = ({
    label,
    value,
    placeholder = "",
    required = false,
    onChange,
    className,
    name,
    hidelabel,
    disabled,
                                                   labelClassName
}) => {

    const baseClasses = 'col-span-12 grid grid-cols-12 gap-3';
    const labelClasses = 'col-span-3 sm:mt-2 lg:mt-0 mt-2 flex items-center';
    const inputClasses = `relative ${hidelabel ? 'col-span-12' : 'col-span-9'}`;
    return (
        <>
            <div className={baseClasses}>
                {!hidelabel && <div className={labelClasses}>
                    <span className={`text-surface-0 ${labelClassName}` }>
                        {required ? `*${label}` : label}
                    </span>

                </div>}
                <div className={inputClasses}>
                    <NumberFormat
                        name={name}
                        className={`font-normal rounded-md border border-surface-5 text-sm text-surface-0 form_control p-2 w-[100%] mt-3 ${disabled ? 'bg-surface-5' : ''}`}
                        placeholder={placeholder}
                        format="(###) ###-####"
                        mask="_"
                        value={value}
                         onChange={onChange}
                        disabled={disabled}
                    />
                </div>
            </div>

        </>
    )
}

export default NumberFormatField;